<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    @input="$emit('input', $event)"
    outlined
  >
    <template #label>
      {{ label }}
      <span v-if="required" class="red--text"><strong>*</strong></span>
    </template>
  </v-text-field>
</template>

<script>
  export default {
    inheritAttrs: false, // Do not inherit attributes on the root component
    props: {
      label: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['input'],
  }
</script>
